import { loadable } from '@tapestry/shared/lazy-load';

export const DynamicDateRangePicker = loadable(
  () => import('./DateRangePicker'),
  { chunkName: 'datepicker', ssr: false }
);
